import { FIELDS } from './constants';

const defaultFields = [
  /*{
    field: 'commands',
    title: ' ',
    cell: 'commands',
    headerCell: 'commandsHeader',
    sortable: false,
    hidden: false,
    locked: true,
    width: 40,
  },
  {
    field: 'selectcommands',
    title: ' ',
    cell: 'selectcommands',
    headerCell: 'selectCommandsHeader',
    sortable: true,
    hidden: false,
    locked: true,
    width: 30,
  },*/
  {
     key: 'partNumber',
     field: FIELDS.PART_NUMBER,
     title: 'Part Number',
     label: 'Part Number',
     cell: 'navigation',
     sortable: true,
     hidden: false,
  },{
     key: 'onHand',
     field: FIELDS.ON_HAND,
     title: 'Local Inventory',
     label: 'On Hand',
     cell: 'formatSeparator',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'oemExcess',
     field: FIELDS.OEMEXCESS,
     title: 'OEM Excess',
     label: 'OEM Excess',
     cell: 'formatSeparator',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'vendorExcess',
     field: FIELDS.VENDOR_EXCESS,
     title: 'Vendor Excess',
     label: 'Vendor Excess',
     cell: 'formatSeparator',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'consignment',
     field: FIELDS.CONSIGNMENT,
     title: 'Consignment',
     label: 'Consignment',
     cell: 'formatSeparator',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'inTesting',
     field: FIELDS.IN_TESTING,
     title: 'In Testing',
     label: 'In Testing',
     cell: 'formatSeparator',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'allocated',
     field: FIELDS.ALLOCATED,
     title: 'Allocated',
     label: 'Allocated',
     cell: 'formatSeparator',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'available',
     field: FIELDS.AVAILABLE,
     title: 'Available',
     label: 'Available',
     cell: 'formatSeparator',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'returned',
     field: FIELDS.RETURNED,
     title: 'Returned',
     label: 'Returned',
     cell: 'formatSeparator',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'destroyed',
     field: FIELDS.DESTROYED,
     title: 'Destroyed',
     label: 'Destroyed',
     cell: 'formatSeparator',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'internalPn',
     field: FIELDS.INTERNAL_PN,
     title: 'Internal PN',
     label: 'Internal PN',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'nsnNumber',
     field: FIELDS.NSNNUMBER,
     title: 'NSN',
     label: 'NSN',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'altNumber',
     field: FIELDS.ALT_NUMBER,
     title: 'Alt Number',
     label: 'Alt Number',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'sku',
     field: FIELDS.SKU,
     title: 'SKU',
     label: 'SKU',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'harmonizedCode',
     field: FIELDS.HARMONIZED_CODE,
     title: 'HTS Code',
     label: 'HTS Code',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'mfgName',
     field: FIELDS.MFG_NAME,
     title: 'Mfr',
     label: 'Mfr',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'altMfr',
     field: FIELDS.ALT_MFR,
     title: 'Alt Mfr',
     label: 'Alt Mfr',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'className',
     field: FIELDS.CLASS_NAME,
     title: 'Class',
     label: 'Class',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'categoryName',
     field: FIELDS.CATEGORY_NAME,
     title: 'Category',
     label: 'Category',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'uom',
     field: FIELDS.UOM,
     title: 'UOM',
     label: 'UOM',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'package',
     field: FIELDS.PACKAGE,
     title: 'Package',
     label: 'Package',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'physPkg',
     field: FIELDS.PHYS_PKG,
     title: 'Phys Pkg',
     label: 'Phys Pkg',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'piecePerPkg',
     field: FIELDS.PIECE_PER_PKG,
     title: 'SPQ',
     label: 'SPQ',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'leadFree',
     field: FIELDS.LEAD_FREE,
     title: 'RoHS',
     label: 'RoHS',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'description',
     field: FIELDS.DESCRIPTION,
     title: 'Description',
     label: 'Description',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'tempRating',
     field: FIELDS.TEMP_RATING,
     title: 'Temp Rating',
     label: 'Temp Rating',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'size',
     field: FIELDS.SIZE,
     title: 'Size',
     label: 'Size',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'voltage',
     field: FIELDS.VOLTAGE,
     title: 'Voltage',
     label: 'Voltage',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'amperage',
     field: FIELDS.AMPERAGE,
     title: 'Amperage',
     label: 'Amperage',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'resolution',
     field: FIELDS.RESOLUTION,
     title: 'Resolution',
     label: 'Resolution',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'watts',
     field: FIELDS.WATTS,
     title: 'Watts',
     label: 'Watts',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'cdm2',
     field: FIELDS.CDM2,
     title: 'Cdm2',
     label: 'Cdm2',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'comments',
     field: FIELDS.COMMENTS,
     title: 'Comments',
     label: 'Comments',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'dateCreated',
     field: FIELDS.DATE_CREATED,
     title: 'Date Created',
     label: 'Date Created',
     cell: 'formatDate',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'dateModified',
     field: FIELDS.DATE_MODIFIED,
     title: 'Date Modified',
     label: 'Date Modified',
     cell: 'formatDate',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'createdByUserFullName',
     field: FIELDS.CREATED_BY_USER_FULL_NAME,
     title: 'Created By',
     label: 'Created By',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'modifiedByUserFullName',
     field: FIELDS.MODIFIED_BY_USER_FULL_NAME,
     title: 'Modified By',
     label: 'Modified By',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'assetAccountName',
     field: FIELDS.ASSET_ACCOUNT_NAME,
     title: 'Asset Account',
     label: 'Asset Account',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'expenseAccountName',
     field: FIELDS.EXPENSE_ACCOUNT_NAME,
     title: 'Expense Account',
     label: 'Expense Account',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'incomeAccountName',
     field: FIELDS.INCOME_ACCOUNT_NAME,
     title: 'Income Account',
     label: 'Income Account',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'cost',
     field: FIELDS.COST,
     title: 'Cost',
     label: 'Cost',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'listPrice',
     field: FIELDS.LIST_PRICE,
     title: 'List Price',
     label: 'List Price',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'resale',
     field: FIELDS.RESALE,
     title: 'Resale',
     label: 'Resale',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'discount1',
     field: FIELDS.DISCOUNT1,
     title: 'Discount 1',
     label: 'Discount 1',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'discount2',
     field: FIELDS.DISCOUNT2,
     title: 'Discount 2',
     label: 'Discount 2',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'discount3',
     field: FIELDS.DISCOUNT3,
     title: 'Discount 3',
     label: 'Discount 3',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'discount4',
     field: FIELDS.DISCOUNT4,
     title: 'Discount 4',
     label: 'Discount 4',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'qtyRequired1',
     field: FIELDS.QTY_REQUIRED1,
     title: 'Qty Required 1',
     label: 'Qty Required 1',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'qtyRequired2',
     field: FIELDS.QTY_REQUIRED2,
     title: 'Qty Required 2',
     label: 'Qty Required 2',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'qtyRequired3',
     field: FIELDS.QTY_REQUIRED3,
     title: 'Qty Required 3',
     label: 'Qty Required 3',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'qtyRequired4',
     field: FIELDS.QTY_REQUIRED4,
     title: 'Qty Required 4',
     label: 'Qty Required 4',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'price1',
     field: FIELDS.PRICE1,
     title: 'Price 1',
     label: 'Price 1',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'price2',
     field: FIELDS.PRICE2,
     title: 'Price 2',
     label: 'Price 2',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'price3',
     field: FIELDS.PRICE3,
     title: 'Price 3',
     label: 'Price 3',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'price4',
     field: FIELDS.PRICE4,
     title: 'Price 4',
     label: 'Price 4',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'contrastRatio',
     field: FIELDS.CONTRAST_RATIO,
     title: 'Contrast Ratio',
     label: 'Contrast Ratio',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'aspectRatio',
     field: FIELDS.ASPECT_RATIO,
     title: 'Aspect Ratio',
     label: 'Aspect Ratio',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'operTemp',
     field: FIELDS.OPER_TEMP,
     title: 'Oper Temp',
     label: 'Oper Temp',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'storTemp',
     field: FIELDS.STOR_TEMP,
     title: 'Stor Temp',
     label: 'Stor Temp',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'polarizerType',
     field: FIELDS.POLARIZER_TYPE,
     title: 'Polarizer Type',
     label: 'Polarizer Type',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'backlighting',
     field: FIELDS.BACKLIGHTING,
     title: 'Backlighting',
     label: 'Backlighting',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'dataConn',
     field: FIELDS.DATA_CONN,
     title: 'Data Conn',
     label: 'Data Conn',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'blConn',
     field: FIELDS.BLCONN,
     title: 'BL Conn',
     label: 'BL Conn',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'isService',
     field: FIELDS.IS_SERVICE,
     title: 'Service',
     label: 'Service',
     cell: 'checkMark',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'scheduleB',
     field: FIELDS.SCHEDULE_B,
     title: 'Sched B',
     label: 'Sched B',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'eccn',
     field: FIELDS.ECCN,
     title: 'ECCN',
     label: 'ECCN',
     sortable: true,
     hidden: true,
     width: 150,
  },
  {
    field: 'deletecommands',
    title: ' ',
    cell: 'deletecommands',
    headerCell: 'commandsHeader',
    sortable: true,
    hidden: false,
    locked: true,
    width: 30,
  },
]

export default defaultFields;
